// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.98.0_esbuild@0.25.0_/node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.98.0_esbuild@0.25.0_/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================================================
#    Colors
   ========================================================================== */
/*\$mainColor:#d40621;
\$alphaLight:rgba(#fff, .5);
\$alphaDark:rgba(#000, .5);
\$placeholderTextLight:rgba(#fff, .7);
\$placeholderTextDark:rgba(#000, .7);

\$textLight: #fff;
\$textDark: #404040;
\$textThemes:#d40621;*/
/* ################## */
/* ################## */
/* ################## */
/* ################## */
.progressbar {
  position: absolute;
  left: 0;
  right: 0;
  z-index: 2;
  background: #ffffff;
  height: 5px;
  width: 100%;
  transition: height 0.2s linear;
  overflow: hidden;
}
.progressbar.-rounded {
  border-radius: 4px;
}
.progressbar.-big {
  height: 20px;
}
.progressbar.-static {
  display: block;
  position: static;
}
.progressbar.-fixed {
  top: 75px;
  position: fixed;
}
.progressbar.-positionTop {
  top: 0;
}
.progressbar.js-disable {
  height: 0;
  transition-delay: 0.3s;
}
.progressbar__line {
  display: block;
  overflow: hidden;
  position: relative;
  width: inherit;
  height: inherit;
}

.bar, .determinate, .indeterminate {
  position: absolute;
  background: var(--c_mainColorDark);
  height: inherit;
}
.bar.-rounded, .-rounded.determinate, .-rounded.indeterminate {
  border-radius: 20px;
}
.bar.-light, .-light.determinate, .-light.indeterminate {
  background: var(--c_mainColorLight);
}

.indeterminate {
  animation: indeterminateBar 2s 0.5s infinite;
}

.determinate {
  transition: transform 0.5s ease-in-out;
  width: 100%;
  transform-origin: top left;
}

@keyframes indeterminateBar {
  0% {
    left: -70%;
    width: 70%;
  }
  100% {
    left: 105%;
    width: 5%;
  }
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
